import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=048201f8&scoped=true&"
import script from "./Performance.vue?vue&type=script&lang=js&"
export * from "./Performance.vue?vue&type=script&lang=js&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=048201f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048201f8",
  null
  
)

export default component.exports